// UI strings for the Halloween-mittari (Axel's decision of 2026-10-09; app/src/halloweenmeter/): one quiet
// sentence per person in the shared record, on the Halloween page and in the finale's week hub, and the
// lines one word away. Finnish (default) and English side by side, the same shape. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

const fiFeast = (n: number) => (n === 1 ? '1 sitsilauseen' : `${n} sitsilausetta`);
const enFeast = (n: number) => (n === 1 ? '1 feast line' : `${n} feast lines`);

/** "38 / 226 Targaryenien repliikkiä ja 9 sitsilausetta" (a part with no line understood is left out). */
const fiWhat = (show: number, total: number, feast: number) =>
  [show > 0 ? `${show} / ${total} Targaryenien repliikkiä` : '', feast > 0 ? fiFeast(feast) : ''].filter(Boolean).join(' ja ');
const enWhat = (show: number, total: number, feast: number) =>
  [show > 0 ? `${show} / ${total} of the Targaryens’ lines` : '', feast > 0 ? enFeast(feast) : ''].filter(Boolean).join(' and ');

export const halloweenMeterFi = {
  you: (show: number, total: number, feast: number) => `Ymmärrät nyt ${fiWhat(show, total, feast)}.`,
  partner: (name: string, show: number, total: number, feast: number) => `${name} ymmärtää nyt ${fiWhat(show, total, feast)}.`,
  /** The list under my sentence (a tap opens it). */
  nearTitle: 'Näistä puuttuu enää yksi sana',
  missing: 'Puuttuu:',
  /** A script line's speaker label. */
  feastLine: 'Sitsilause',
};

export const halloweenMeterEn: typeof halloweenMeterFi = {
  you: (show: number, total: number, feast: number) => `You now understand ${enWhat(show, total, feast)}.`,
  partner: (name: string, show: number, total: number, feast: number) => `${name} now understands ${enWhat(show, total, feast)}.`,
  nearTitle: 'One word away',
  missing: 'Missing:',
  feastLine: 'Feast line',
};

// Messages.halloweenMeter (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('halloweenMeter', halloweenMeterFi, halloweenMeterEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof halloweenMeterFi> {}
}
